/**
 * Centralized localStorage key management
 *
 * This file provides type-safe localStorage key generation functions
 * to ensure consistency across the application and make refactoring easier.
 */

export const STORAGE_KEYS = {
  nemoClawBannerDismissed: "nemoclaw-promo-banner-dismissed",

  /** Key for storing stop modal dismissal state for free-tier instances only */
  stopFreeTierModalDismissed: "stop-free-tier-modal-dismissed",
  sensorCarlineAgentBannerDismissed: "sensor-carline-agent-banner-dismissed",
} as const;
